import React from 'react';
import { css } from '@emotion/core';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Address = _ref => {
  var address = _ref.address;
  return address ? ___EmotionJSX("strong", {
    css: /*#__PURE__*/css(designTokenFonts.bodyBold)
  }, address === null || address === void 0 ? void 0 : address.line1, ", ", address === null || address === void 0 ? void 0 : address.division.name, ", ", address === null || address === void 0 ? void 0 : address.state.abbrev, ' ', address === null || address === void 0 ? void 0 : address.postcode) : null;
};
export default Address;